import React, { useState} from 'react';
import {useAppSelector} from "../../creator-presets/DAL/store";
import {useIsOverflow, useWindowSize} from "../../../../domain/common";
import {PresetTagDM} from "../../common/interfaces";
import {MAX_MOBILE_SIZE, MAX_TABLET_WIDTH} from "../../common/constants";
import {sendGAEvent} from "../../../../domain/marketing/gtm-provider";

const PresetTags = () => {
    const [isAllTags, setIsAllTags] = useState(false);

    const PresetPageData = useAppSelector((store) => store.PresetPageData);
    const mainPreset = useAppSelector((store) => store.mainPreset);
    const mainPresetTags = (PresetPageData.presetTags as PresetTagDM[]).filter(presetTag => mainPreset.presetID === presetTag.presetID);
    const size = useWindowSize();
    const getMaxTagsInRow = () => {
        if(size.width !== undefined && size.width > MAX_TABLET_WIDTH){
            return 8;
        }else if(size.width !== undefined && size.width > MAX_MOBILE_SIZE){
            return 5;
        }else{
            return 2;
        }
    }
    const maxTagsInRow = getMaxTagsInRow();

    const allTagsRef = React.useRef(null);

    const isOverflow = useIsOverflow(allTagsRef);

    return (
        <div className="w-full">
            <div className="w-full border-b border-b-gray-600 my-6"></div>
            <div className={`w-full text-sm md:text-base`}>
                {!isOverflow ?
                    <div className="w-full text-sm md:text-base flex items-center">
                        <span className="text-base font-bold w-auto">Tags</span>
                        <div className="flex-1  flex items-center overflow-auto" ref={allTagsRef}>
                            {mainPresetTags.map((presetTag,index) => {
                                return   <a className="inline-block text-black border-gray-200 border no-underline p-1 px-2 bg-gray-100 m-2"
                                           key={index.toString() + presetTag.tagAlias} style={{borderRadius:"8px"}}
                                            onClick={(evt) => {
                                                sendGAEvent('Click', "Tag: " + presetTag.tagAlias);
                                            }}
                                           href={"/studioverse/chains/tag/" + presetTag.tagAlias}>
                                                    {presetTag.tagName}
                                        </a>
                            })}
                        </div>


                    </div>
                :
                    <div className={`"w-full text-sm md:text-base ${isAllTags ? "":"flex items-center justify-center"}"`}>
                        <div className="text-base font-bold">Tags</div>
                        <div className={`${isAllTags ? "w-full ":"flex-1"}`}>
                            {mainPresetTags.map((presetTag,index) => {
                                if(isAllTags || index  < maxTagsInRow){
                                    return <a key={presetTag.tagAlias + index.toString()}
                                                    className={`inline-block text-black border-gray-200 border no-underline p-1 px-2 bg-gray-100 mx-2 ${isAllTags ? "mt-8 ":""}`}
                                                    style={{borderRadius:"8px"}}
                                                      onClick={(evt) => {
                                                          sendGAEvent('Click', "Tag: " + presetTag.tagAlias);
                                                      }}
                                                    href={"/studioverse/chains/tag/" + presetTag.tagAlias}>
                                            {presetTag.tagName}
                                        </a>
                                }else {return null;}
                            })}

                        </div>

                        {!isAllTags ?
                            <div className="underline cursor-pointer" onClick={() => setIsAllTags(true)}>show more</div>
                            :
                            <div className="w-full underline cursor-pointer mt-8" onClick={() => setIsAllTags(false)}>show less</div>
                        }

                    </div>
                }

            </div>
            <div className="w-full border-b border-b-gray-600 my-6"></div>
        </div>

    )
};

export default PresetTags;